import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
// import AsyncSelect from "react-select/async";
// import { getPatients } from "../InvestigationReport/services/report-service";
import {
  patiantInvoiceService,
  patiantSuggestionService,
  uploadInvoiceService,
} from "./services/search-patient";
import SuggestionTable from "./SuggestionTable";
import InvoiceTable from "./InvoiceTable";
import { toast } from "react-toastify";
import SearchPatientModel from "./SearchPatientModal";
// import { dummyInvoices, dummyPatients, dummySuggestions } from "./data/data";
import { InputGroup } from "react-bootstrap";

import { FiPhoneCall } from "react-icons/fi";
import { TfiEmail } from "react-icons/tfi";
import { FaLocationDot } from "react-icons/fa6";
import moment from "moment";
import errorProfile from "../.././assets/images/blank_profile.png";
import S3ImageLoader from "../../S3ImageLoader";
const imageBaseURL = process.env.REACT_APP_BASE_URL;

// const selectStyles = {
//   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//   control: (base) => ({ ...base, minHeight: "38px" }),
// };

{
  /* 
const getPatients = async ({ search }) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const filtered = dummyPatients.filter((p) =>
        p.full_name.toLowerCase().includes(search.toLowerCase())
      );
      resolve({
        data: {
          data: {
            patients: filtered,
          },
        },
      });
    }, 500);
  });
};

const patiantSuggestionService = async ({ patient_id }) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const filteredSuggestions = dummySuggestions.filter(
        (suggestion) => suggestion.patient._id === patient_id
      );
      resolve({
        data: {
          data: {
            suggestion: filteredSuggestions,
          },
        },
      });
    }, 500);
  });
};

const patiantInvoiceService = async (patient_id) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const filteredInvoices = dummyInvoices.filter(
        (invoice) => invoice.patient._id === patient_id
      );
      resolve({
        data: {
          data: {
            invoices: filteredInvoices,
          },
        },
      });
    }, 500);
  });
};

const uploadInvoiceService = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {
          status: "success",
          message: "Report uploaded successfully",
        },
      });
    }, 1000);
  });
};
*/
}

const SearchPatient = () => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [UploadModelOpen, setUploadModelOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [suggestions, setSuggestions] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [invoicesLoading, setInvoicesLoading] = useState(false);
  const [reportUploading, setReportUploading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [searchQuery, setSearchQuery] = useState("");
  const [isPatientModal, setIsPatientModal] = useState(false);

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (selectedPatient) {
      getData();
    }
  }, [selectedPatient]);

  const getData = async () => {
    setSuggestionsLoading(true);
    setInvoicesLoading(true);

    const suggestionForm = {
      patient_id: selectedPatient._id,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const suggestion = await patiantSuggestionService(suggestionForm);
      setSuggestions(suggestion.data?.data?.suggestion || []);
      setSuggestionsLoading(false);

      const invoices = await patiantInvoiceService(selectedPatient._id);
      setInvoices(invoices.data?.data?.invoices || []);
      setInvoicesLoading(false);
    } catch (error) {
      console.error("Error fetching patient data:", error);
      setSuggestionsLoading(false);
      setInvoicesLoading(false);
    }
  };

  // const loadPatients = async (inputValue) => {
  //   if (!inputValue || inputValue.length < 3) {
  //     return [];
  //   }

  //   const body = {
  //     search: inputValue,
  //   };

  //   try {
  //     const response = await getPatients(body);
  //     const patients = response.data.data.patients || [];
  //     return patients.map((patient) => ({
  //       value: patient._id,
  //       label: patient.full_name,
  //       data: patient,
  //     }));
  //   } catch (error) {
  //     console.error("Error searching patients:", error);
  //     return [];
  //   }
  // };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // const handleSelectPatient = async (selectedOption) => {
  //   const patient = selectedOption ? selectedOption.data : null;
  //   setSelectedPatient(patient);

  //   if (patient) {
  //     setSuggestionsLoading(true);
  //     setInvoicesLoading(true);

  //     const suggestionForm = {
  //       patient_id: patient._id,
  //       pageNo: 1,
  //       pageSize: 10,
  //     };

  //     try {
  //       const suggestion = await patiantSuggestionService(suggestionForm);
  //       setSuggestions(suggestion.data?.data?.suggestion || []);
  //       setSuggestionsLoading(false);

  //       const invoices = await patiantInvoiceService(patient._id);
  //       setInvoices(invoices.data?.data?.invoices || []);
  //       setInvoicesLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching patient data:", error);
  //       setSuggestionsLoading(false);
  //       setInvoicesLoading(false);
  //     }
  //   }
  // };

  const toggleUploadModel = () => setUploadModelOpen(!UploadModelOpen);

  const handleUploadSubmit = async () => {
    let formErrors = {};
    if (!file) formErrors.file = "Please select a file.";
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    const formData = new FormData();
    formData.append("patient_id", selectedPatient._id);
    formData.append("document", file);

    setReportUploading(true);
    try {
      const res = await uploadInvoiceService(formData);
      if (res.data.status === "success") {
        toast.success("Report Uploaded Successfully");
        setErrors({});
        setFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setUploadModelOpen(false);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.error("Error while uploading report", error);
    } finally {
      setReportUploading(false);
    }
  };

  const handleSearchClick = () => {
    if (searchQuery.trim().length >= 3) {
      setIsPatientModal(true);
    } else {
      toast.error("Please enter at least 3 characters to search");
    }
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearchClick();
    }
  };

  const calculateAge = (birthDate) => {
    const birthDateMoment = moment(birthDate); // Parse the birth date
    const currentDate = moment(); // Get the current date
    // Calculate the difference in years
    const age = currentDate.diff(birthDateMoment, "years");
    return age;
  };

  return (
    <>
      <Card className="tw-min-h-screen">
        <CardBody>
          <CardTitle tag={"h3"} className="mb-3 tw-font-bold">
            Search Patient
          </CardTitle>
          <div className="tw-w-full tw-flex tw-gap-2 tw-items-center">
            <div className="tw-flex-1">
              <InputGroup className="custom-input-group">
                <Input
                  type="search"
                  className="search-bar patient-search-bar tw-rounded-s-full"
                  placeholder="Search Patient by NAKBHO ID / Name / Email / Phone"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={handleSearchKeyPress}
                />
                <InputGroup.Text
                  onClick={handleSearchClick}
                  className="text-white patient-search-icon-btn tw-rounded-e-full"
                  style={{
                    backgroundColor: "var(--theme-default)",
                    background:
                      "linear-gradient(180.05deg, #006E27 20.14%, #033415 87.13%)",
                  }}
                >
                  <i
                    className="fa fa-search"
                    style={{ fontSize: "14px", height: "22px", width: "16px" }}
                  ></i>
                </InputGroup.Text>
              </InputGroup>
              {/* <AsyncSelect
              className="tw-w-full"
              cacheOptions
              defaultOptions
              loadOptions={loadPatients}
              value={
                selectedPatient
                  ? {
                      value: selectedPatient._id,
                      label: selectedPatient.full_name,
                      data: selectedPatient,
                    }
                  : null
              }
              onChange={(selectedOption) => handleSelectPatient(selectedOption)}
              placeholder="Search patient by name or phone..."
              noOptionsMessage={({ inputValue }) =>
                inputValue.length < 3
                  ? "Type at least 3 characters"
                  : "No patients found"
              }
              styles={selectStyles}
              isClearable
              menuPortalTarget={document.body}
              menuShouldScrollIntoView={true}
            /> */}
            </div>
            {selectedPatient && (
              <Button
                color="primary"
                className="tw-whitespace-nowrap"
                onClick={toggleUploadModel}
              >
                Upload Report
              </Button>
            )}
          </div>
          {selectedPatient && (
            <>
              {/* <Card className="mt-4">
              <CardBody>
                <CardTitle tag="h5">Patient Details</CardTitle>
                <Row className="tw-my-3">
                  <Col sm="6">
                    <p>
                      <strong>Name:</strong>&nbsp;
                      {selectedPatient?.full_name || "N/A"}
                    </p>
                  </Col>
                  <Col sm="6">
                    <p>
                      <strong>NAKBHO Health ID:</strong>&nbsp;
                      {selectedPatient?.health_id || "N/A"}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6">
                    <p>
                      <strong>Gender:</strong>&nbsp;
                      {selectedPatient?.gender
                        ? selectedPatient.gender.charAt(0).toUpperCase() +
                          selectedPatient.gender.slice(1)
                        : "N/A"}
                    </p>
                  </Col>
                  <Col sm="6">
                    <p>
                      <strong>Age:</strong> {selectedPatient?.age || "N/A"}
                    </p>
                  </Col>
                </Row>
              </CardBody>
            </Card> */}
              <div className="mt-4">
                <Card className="patient-card-background">
                  <div className="p-2">
                    <div className="p-2 d-flex tw-space-x-2">
                      <S3ImageLoader
                        fileName={selectedPatient?.profile_picture}
                        fallbackSrc={errorProfile}
                        className="patient-pic img-60"
                        alt="Patient"
                      />
                      <div className="ps-3">
                        <h6 className="mb-0">
                          <strong>
                            {selectedPatient.first_name}{" "}
                            {selectedPatient.middle_name}{" "}
                            {selectedPatient.last_name}
                          </strong>
                        </h6>
                        <small
                          style={{
                            fontSize: "12px",
                            textTransform: "capitalize",
                          }}
                        >
                          {selectedPatient.gender},{" "}
                          {moment(selectedPatient.dob).format("DD MMM YYYY")}{" "}
                          Age {calculateAge(selectedPatient.dob)}
                        </small>
                        <div className="patient-healthId-text tw-min-w-max">
                          {selectedPatient.health_id
                            ?.match(/.{1,4}/g)
                            .join(" ")}
                        </div>
                      </div>
                      <div className="row ps-3">
                        <div className="col-md-6">
                          <div className="d-flex align-items-center">
                            <div className="p-0 rounded-circle me-2">
                              <FiPhoneCall />
                            </div>
                            <span style={{ fontSize: "12px" }}>
                              {selectedPatient.phone_code}{" "}
                              {selectedPatient.mobile}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="d-flex align-items-center">
                            <div className="p-0 rounded-circle me-2">
                              <TfiEmail />
                            </div>
                            <span style={{ fontSize: "12px" }}>
                              {selectedPatient.email}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="d-flex align-items-center">
                            <div className="p-0 rounded-circle me-2">
                              <FaLocationDot />
                            </div>
                            <small>{selectedPatient.address}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>

              <Card className="mt-4">
                <CardBody>
                  <Nav tabs className="w-100">
                    <NavItem className="text-center w-50">
                      <NavLink
                        className={`tw-cursor-pointer w-100 text-center py-2 ${
                          activeTab === "1" && "active"
                        }`}
                        style={
                          activeTab === "1"
                            ? {
                                backgroundColor: "var(--theme-default)",
                                background:
                                  "linear-gradient(180.05deg, #006E27 20.14%, #033415 87.13%)",
                                color: "white",
                              }
                            : {}
                        }
                        onClick={() => toggleTab("1")}
                      >
                        Suggestions
                      </NavLink>
                    </NavItem>
                    <NavItem className="text-center w-50">
                      <NavLink
                        className={`tw-cursor-pointer w-100 text-center py-2 ${
                          activeTab === "2" && "active"
                        }`}
                        style={
                          activeTab === "2"
                            ? {
                                backgroundColor: "var(--theme-default)",
                                background:
                                  "linear-gradient(180.05deg, #006E27 20.14%, #033415 87.13%)",
                                color: "white",
                              }
                            : {}
                        }
                        onClick={() => toggleTab("2")}
                      >
                        Invoices
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={activeTab} className="mt-3">
                    <TabPane tabId="1">
                      <SuggestionTable
                        suggestions={suggestions}
                        loading={suggestionsLoading}
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <InvoiceTable
                        invoices={invoices}
                        loading={invoicesLoading}
                      />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </>
          )}
        </CardBody>
      </Card>

      {/* Upload Report Modal */}
      <Modal isOpen={UploadModelOpen} toggle={toggleUploadModel}>
        {reportUploading && (
          <div
            className="top-0 rounded position-absolute start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 1050,
            }}
          >
            <div
              className="spinner-border"
              style={{ color: "var(--theme-default)" }}
              role="status"
            >
              <span className="visually-hidden">Uploading...</span>
            </div>
            <div className="mt-3" style={{ color: "var(--theme-default)" }}>
              Extracting details from report...
            </div>
          </div>
        )}

        <ModalHeader toggle={toggleUploadModel}>
          Upload Report for <strong>{selectedPatient?.full_name}</strong>
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="reportFile">Report File</Label>
              <Input
                type="file"
                id="reportFile"
                accept=".pdf, image/jpeg, image/jpg, image/png"
                innerRef={fileInputRef}
                onChange={(e) => {
                  const selected = e.target.files[0];
                  if (selected) {
                    const allowedTypes = [
                      "application/pdf",
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                    ];
                    if (!allowedTypes.includes(selected.type)) {
                      setErrors((prev) => ({
                        ...prev,
                        file: "Only PDF or image files (jpg, jpeg, png) are allowed.",
                      }));
                      setFile(null);
                      if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                      }
                      return;
                    }
                    setErrors((prev) => ({ ...prev, file: "" }));
                    setFile(selected);
                  }
                }}
                disabled={reportUploading}
              />
              {errors.file && (
                <div className="mt-1 text-danger">{errors.file}</div>
              )}
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleUploadSubmit}
            disabled={reportUploading}
          >
            {reportUploading ? "Submitting..." : "Submit"}
          </Button>
          <Button
            color="secondary"
            onClick={toggleUploadModel}
            disabled={reportUploading}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <SearchPatientModel
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        isPatientModal={isPatientModal}
        setIsPatientModal={setIsPatientModal}
        handleSelectPatient={(patient) => {
          setSelectedPatient(patient);
          setIsPatientModal(false);
        }}
      />
    </>
  );
};

export default SearchPatient;
